<template>
  <pilot-trials mode="practice" />
</template>

<script>
import PilotTrials from './PilotTrials.vue';

export default {
  name: 'Practice',
  components: { PilotTrials },
};
</script>
